import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';
import { UserProvider } from '../../providers/user';
import { AppVersion } from '@ionic-native/app-version';

@NgModule({
    declarations: [
        LoginPage
    ],
    imports: [
        IonicPageModule.forChild(LoginPage)
    ],
    providers: [
        UserProvider,
        AppVersion
    ]
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts